import {
	WORK_ASSIGNMENT_EXTRA_ACTIVITY_ERROR_RESPONSE,
	WORK_ASSIGNMENT_EXTRA_ACTIVITY_SUCCESS_RESPONSE,
} from 'common/activeElements/modals/ManageExtraActivity/const';
import { mapOverlappingActivitiesErrors } from 'common/OverlappingActivitiesBanner/helpers/overlappingActivities';
import { client } from 'contexts/ApolloClient/apolloClient';
import { standardDeletedSuccess, standardError } from 'global/commonMessages';
import { notificationStore } from 'global/NotificationStore';

import { REJECT_EXTRA_ACTIVITY_ASSIGNMENT } from './gql/rejectExtraActivityAssignment';

const normalizeValidationErrors = (errors = []) => {
	if (!Array.isArray(errors)) return [];

	return errors.map((error) => {
		if (typeof error === 'string') return error;
		return error?.message ?? error?.code ?? error?.error ?? error?.type ?? JSON.stringify(error);
	});
};

export const rejectExtraActivityAssignment = async (workAssignmentKey) => {
	if (!workAssignmentKey?.id || workAssignmentKey.version == null) {
		notificationStore.setNotification(standardError);
		return null;
	}

	try {
		const response = await client.mutate({
			mutation: REJECT_EXTRA_ACTIVITY_ASSIGNMENT,
			variables: {
				workAssignmentKey,
			},
			fetchPolicy: 'no-cache',
		});
		const result = response.data?.rejectExtraActivityAssignment;

		if (result?.__typename === WORK_ASSIGNMENT_EXTRA_ACTIVITY_SUCCESS_RESPONSE) {
			notificationStore.setNotification(standardDeletedSuccess);
			return result.workAssignmentSequence ?? null;
		}

		if (result?.__typename === WORK_ASSIGNMENT_EXTRA_ACTIVITY_ERROR_RESPONSE) {
			notificationStore.setNotification(
				mapOverlappingActivitiesErrors(normalizeValidationErrors(result.errors))
			);
			return null;
		}

		notificationStore.setNotification(standardError);
		return null;
	} catch (error) {
		notificationStore.setNotification(standardError);
		return null;
	}
};
